export const MOBILE_LAYOUT_LENGTH = "899px";
export const PC_LAYOUT_LENGTH = "1199px";
export const KO_TITLE = "스케치 (Join the Sketch revolution)";
export const KO_DESCRIPTION =
  "스케치 프로젝트가 웹 3.0 디지털 세상을 만들어갑니다. 스케치의 메인넷과 함께 Coin, Wallet, Pay, Talk 기능을 만나보세요.";
export const EN_TITLE = "Sketch (Join the Sketch revolution)";
export const EN_DESCRIPTION =
  "The Sketch Project is shaping the Web 3.0 digital world. Experience the Coin, Wallet, Pay, Talk features along with Sketch's mainnet.";
